const initialState = {
  aString: 'Test string',
};

const testReducer = (state = initialState) => {
  // Create dispatch actions here
  return state;
};

export default testReducer;